import { SharedModule } from 'src/app/shared/shared.module';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ErrorPageComponent } from './shared/components/error-page/error-page.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorInterceptor } from './core/interceptors/error/error.interceptor';
import { GenericModalComponent } from './shared/components/generic-modal/generic-modal.component';
import { HeadersInterceptor } from './core/interceptors/headers/headers.interceptor';
import { LoadingInterceptor } from './core/interceptors/loading/loading.interceptor';
@NgModule({
  declarations: [
    AppComponent,
    ErrorPageComponent,
    GenericModalComponent
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    SharedModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeadersInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
  ],
  entryComponents: [
    GenericModalComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
